(function () {
	/**
	 * Updates the URL with the layout parameter
	 * @param {string} layout - The layout value ('small' or 'large')
	 */
	const updateURLParameter = (layout) => {
		const url = new URL(window.location.href);
		url.searchParams.set('layout', layout);
		window.history.pushState({}, '', url);
	};

	/**
	 * Reads the layout parameter from URL and applies it
	 */
	const applyLayoutFromURL = () => {
		const urlParams = new URLSearchParams(window.location.search);
		const layoutParam = urlParams.get('layout');
		
		if (layoutParam === 'small' || layoutParam === 'large') {
			$(".per-row__button").removeClass("active");
			$(`[data-per-row="${layoutParam}"]`).addClass("active");
			$("[data-productis-in-row]").attr(
				"data-productis-in-row",
				layoutParam
			);
		}
	};

	/**
	 * Updates pagination links to include the layout parameter
	 * @param {string} layout - The layout value ('small' or 'large')
	 */
	const updatePaginationLinks = (layout) => {
		// Update standard pagination links
		const paginationLinks = document.querySelectorAll('.pagination__item[href], .pagination__item--prev[href], .pagination__item--next[href]');
		paginationLinks.forEach((link) => {
			const url = new URL(link.href, window.location.origin);
			url.searchParams.set('layout', layout);
			link.href = url.pathname + url.search + url.hash;
		});

		// Update load-more/infinite-scroll data-next-url
		const nextUrlInputs = document.querySelectorAll('input[data-next-url]');
		nextUrlInputs.forEach((input) => {
			const currentUrl = input.value || input.dataset.nextUrl;
			if (currentUrl) {
				const url = new URL(currentUrl, window.location.origin);
				url.searchParams.set('layout', layout);
				const newUrl = url.pathname + url.search + url.hash;
				input.value = newUrl;
				input.dataset.nextUrl = newUrl;
			}
		});
	};

	const productsPerRow = () => {
		// Apply layout from URL on page load
		applyLayoutFromURL();

		// Get current layout to update pagination links
		const getCurrentLayout = () => {
			const urlParams = new URLSearchParams(window.location.search);
			const layoutParam = urlParams.get('layout');
			if (layoutParam === 'small' || layoutParam === 'large') {
				return layoutParam;
			}
			// Fallback to active button or default
			const activeButton = document.querySelector('.per-row__button.active');
			if (activeButton) {
				return activeButton.dataset.perRow;
			}
			return 'small'; // Default
		};

		// Update pagination links on page load
		const currentLayout = getCurrentLayout();
		updatePaginationLinks(currentLayout);

		$(".per-row__button").click(function () {
			const selectedLayout = $(this).data("per-row");
			
			$(".per-row__button").removeClass("active");
			$(`[data-per-row="${selectedLayout}"]`).addClass("active");
			$("[data-productis-in-row]").attr(
				"data-productis-in-row",
				selectedLayout
			);
			
			// Update URL with selected layout
			updateURLParameter(selectedLayout);
			
			// Update pagination links with new layout
			updatePaginationLinks(selectedLayout);
			
			// Trigger custom event for content spot repositioning
			window.dispatchEvent(new CustomEvent("columnsChanged"));
		});
	};

	document.addEventListener("shopify:section:load", function () {
		productsPerRow();
	});
	productsPerRow();
})();
